'use strict';

module.exports = require('./Checkbox');


//////////////////
// WEBPACK FOOTER
// ./~/_rc-checkbox@2.0.2@rc-checkbox/lib/index.js
// module id = 224
// module chunks = 0 1